const fetchCurrentRole = require('public_framework/services/fetch_current_role')

const PLEASE_WAIT_MSG_DELAY = 1500
const urlsCache = {}

const openWindow = (url) => window.open(url)
const fetch = (url, options) => window.fetch(url, options)

function twitterUrl (purl, ptitle, hashtags = null) {
  let url = 'http://twitter.com/share?'
  url += `text=${encodeURIComponent(ptitle)}`
  url += `&url=${encodeURIComponent(purl)}`
  if (hashtags) { url += `&hashtags=${encodeURIComponent(hashtags)}` }
  return (url += `&counturl=${encodeURIComponent(purl)}`)
}

function facebookUrl (purl, ptitle, text, pimg) {
  if (text == null) { text = '' }
  if (pimg == null) { pimg = '' }
  if (window.innerWidth <= 896) return facebookMobileUrl(purl)
  let url = 'http://www.facebook.com/sharer.php?'
  url += `&u=${encodeURIComponent(purl)}`
  url += `&title=${encodeURIComponent(ptitle)}`
  url += `&description=${encodeURIComponent(text)}`
  return (url += `&picture=${encodeURIComponent(pimg)}`)
}

function facebookMobileUrl (purl) {
  return `http://m.facebook.com/sharer.php?u=${encodeURIComponent(purl)}`
}

function linkedinUrl (purl, ptitle, text) {
  if (text == null) { text = '' }
  let url = 'https://www.linkedin.com/shareArticle?mini=true'
  url += `&url=${encodeURIComponent(purl)}`
  url += `&title=${encodeURIComponent(ptitle)}`
  return (url += `&summary=${encodeURIComponent(text)}`)
}

function openPopup (personalMessage) {
  let popup
  const text = personalMessage
    ? 'Please wait while we append your personal referral hashtag into a shorter, more convenient link&hellip;'
    : 'Please wait&hellip;'

  // popup.onload will not work in IE11, onload happens earlier then we attach
  // a handler to it, so we explicitly notify the parent window when popup is ready
  const onMessage = (e) => {
    if (e.data === 'share_popup_ready') {
      popup.document.getElementById('loading_text').innerHTML = text
      // unsubscribe only after successfuly setting the text,
      // there're lots of other `message` events (setImmediate, disqus, etc)
      window.removeEventListener('message', onMessage, false)
    }
  }

  window.addEventListener('message', onMessage)
  popup = window.open('/share_popup.html', '', 'toolbar=0,status=0,width=625,height=435')
  return popup
}

function prepareURL (url) {
  const alreadyPrepared = urlsCache[url]
  if (alreadyPrepared) return Promise.resolve(alreadyPrepared)

  return fetch(`${window.gon.api_shorten_url}?url=${encodeURIComponent(url)}`, {method: 'POST'})
    .then(response => response.json())
    .then(json => {
      urlsCache[url] = json.shorten
      return json.shorten
    })
    .catch(() => url)
}

function composeURLForTarget (url, {target, title, text, hashtags}) {
  switch (target) {
    case 'twitter': return twitterUrl(url, title, hashtags)
    case 'facebook': return facebookUrl(url, title, text)
    case 'linkedin': return linkedinUrl(url, title, text)
  }
}

/**
 * @param {string} url - url to be shared.
 * @param {object} options - sharing options.
 * @param {string} options.target - the network to share page on, see `composeURLForTarget`, can also be `rss`.
 * @param {string} options.title - the title for the share.
 * @param {string} options.text - the text to be shared.
 * @param {string} options.hashtags - hashtags for twitter.
 * @param {string} options.rssUrl - URL of the RSS feed.
 *
 * @return {Promise<void>} - resolves when the action succeeds, rejects when fails (for example is blocked with some Ad-blocker).
 *
 * @description Opens a popup for sharing particular URL on a given network.
 * If options.target is `rss` then opens the feed in a new window, instead of triggering the popup.
 */
export default function share (url, options) {
  if (options.target === 'rss') {
    openWindow(options.rssUrl)
    return Promise.resolve()
  }

  const rolePromise = new Promise(resolve => {
    fetchCurrentRole(user => resolve(!!(user && user.email)))
  })

  return rolePromise.then(isLoggedIn => {
    const popup = openPopup(isLoggedIn)

    return prepareURL(url).then(shortUrl => {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          const popupURL = composeURLForTarget(shortUrl, options)
          if (!popup) return reject(new Error('Popup is not available'))
          popup.location.href = popupURL
          resolve()
        }, PLEASE_WAIT_MSG_DELAY)
      })
    })
  })
}



// WEBPACK FOOTER //
// ./front/apps/shared/javascripts/social_share.js